import { Dispatch, SetStateAction, createContext, useContext } from "react";

export type ConsumerPurchaseLayoutContextState = {
  showCoverageDetailsModalState: [boolean, Dispatch<SetStateAction<boolean>>];
};

const ConsumerPurchaseLayoutContext =
  createContext<ConsumerPurchaseLayoutContextState>(
    {} as ConsumerPurchaseLayoutContextState
  );

export const useConsumerPurchaseLayoutContext = () => {
  return useContext(ConsumerPurchaseLayoutContext);
};

export default ConsumerPurchaseLayoutContext;
